<template>

<div class="product-container mock" v-if="!editing">
	<component v-bind:is="element.name" v-for="(element, index) in getProductSections" :product="product" :key="index"></component>
</div>

<div class="section section-edit product-edit" v-else>
	<div class="product-container-outer" :style="productContainerOuterStyle">
		<div class="product-container editing">
			<draggable v-bind="productSectionsOptions" v-model="productSections">
				<component class="draggable" v-bind:is="element.name" v-for="(element, index) in productSections"
				:productSectionsStyle="productSectionsStyle"
				:product="product"
				:key="index"></component>
			</draggable>
		</div>
	</div>

	<div class="controls template-controls">
		<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save</span></div>
		<div class="button action" @click="saveTemplateData(config.template_id)" v-else><span>Save Tile Layout</span></div>
		<div class="button cancel" v-if="!getTemplateDataChanged" @click="$emit('deSelectSection')">Back</div>
		<div class="button cancel" @click="revertTemplateData(); $emit('deSelectSection');" v-else>Cancel</div>
	</div>

	<div class="three-columns">
		<div class="column">
			<h3>Title</h3>
			<h4>Alignment</h4>
			<ul class="product-text-align-options style-option-group">
				<li class="style-option" :class="{ selected: productSectionsStyle.title.textAlign == textAlign }" @click="productSectionsStyle.title.textAlign = textAlign" v-for="(textAlign, key) in titleOptionsStyle.textAlign" :key="key">{{ key }}</li>
			</ul>
			<h4>Font Size</h4>
			<select v-model="productSectionsStyle.title.fontSize">
				<option v-for="(fontSize, key) in titleOptionsStyle.titleFontSize" :key="key" :value="fontSize">{{ key }}</option>
			</select>
			<h3>Background Color</h3>
			<label class=" checkbox" :class="[ (productSectionsStyle.transparent) ? 'selected' : null ]"><input type="checkbox" v-model="productSectionsStyle.transparent"><span>Transparent</span></label>

			<div :class="{ disabled: productSectionsStyle.transparent }">
				<label>Color</label>
				<color-picker :colors="getColorSchemeColors" :disable="productSectionsStyle.transparent" :selected="productSectionsStyle.backgroundColor.value" @colorClick="productSectionsStyle.backgroundColor.value = $event"></color-picker>
			</div>
		</div>
		<div class="column">
			<h3>Meta</h3>
			<h4>Font Size</h4>
			<select v-model="productSectionsStyle.meta.fontSize">
				<option v-for="(fontSize, key) in titleOptionsStyle.metaFontSize" :key="key" :value="fontSize">{{ key }}</option>
			</select>
			<h3>Text</h3>
			<h4>Color</h4>
			<color-picker :colors="getColorSchemeFontColors" :selected="productSectionsStyle.color.value" @colorClick="productSectionsStyle.color.value = $event"></color-picker>
		</div>
		<div class="column">
			<h3>Price</h3>
			<h4>Font Size</h4>
			<select v-model="productSectionsStyle.price.fontSize">
				<option v-for="(fontSize, key) in titleOptionsStyle.priceFontSize" :key="key" :value="fontSize">{{ key }}</option>
			</select>
		</div>
	</div>
</div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductTitle from './ProductTitle'
import ProductImageLink from './ProductImageLink'
import ProductMetaPrice from './ProductMetaPrice'
import ProductControls from './ProductControls'
import ColorPicker from '../components/ColorPicker'
export default {
	name: 'product',
	props: ['config', 'editing', 'product'],
    components: {
        'product-title': ProductTitle,
        'product-image-link': ProductImageLink,
        'product-meta-price': ProductMetaPrice,
        'product-controls': ProductControls,
        'color-picker': ColorPicker,
    },
	data() {
		return {
			localProduct: {
				title: null,
				product_id: null,
				upc: null,
				price: null,
				image_url: null
			},
			productSectionsStyle: {
				backgroundColor: "#ffffff",
				transparent: null,
				color: "#000000",
				title: {
					textAlign: '',
					fontSize: '',
				},
				meta: {
					fontSize: ''
				},
				price: {
					fontSize: ''
				},
				detailsButton: {
					color: '',
					backgroundColor: ''
				},
				cartButton: {
					color: '',
					backgroundColor: ''
				}
			},
			productSectionsStyleCopy: {
				backgroundColor: {
                    value: null,
                    defaultColor: 1
                },
				transparent: null,
				color: {
                    value: null,
                    defaultColor: 2
                },
				title: {
					textAlign: '',
					fontSize: '',
				},
				meta: {
					fontSize: ''
				},
				price: {
					fontSize: ''
				},
				detailsButton: {
					color: '',
					backgroundColor: ''
				},
				cartButton: {
					color: '',
					backgroundColor: ''
				}
			},
			titleOptionsStyle: {
				textAlign: {
					"Left": "left",
					"Center": ""
				},
				titleFontSize: {
					"-2": "100%",
					"-1": "120%",
					"Default": "",
					"+1": "170%"
				},
				metaFontSize: {
					"-2": "60%",
					"-1": "80%",
					"Default": "",
					"+1": "120%"
				},
				priceFontSize: {
					"-2": "120%",
					"-1": "150%",
					"Default": "",
					"+1": "200%"
				},
				backgroundColor: [
					'#1c3a52',
					'#000000',
					'#ffffff'
				]
			}
		}
	},
	mounted() {
		this.productSectionsStyle = this.$copy(this.getProductSectionsStyles)
		this.productSectionsStyleCopy = this.$copy(this.getProductSectionsStyles)
	},
	watch: {
		productSectionsStyle: {
			handler: function(newVal, oldVal) {
				if (this.$changed(newVal, this.productSectionsStyleCopy)) {
					this.updateProductSectionsStyles(newVal)
				}
			},
			deep: true
		},
		getProductSectionsStyles(newVal, oldVal) {
			this.productSectionsStyle = this.$copy(this.getProductSectionsStyles)
			this.productSectionsStyleCopy = this.$copy(this.getProductSectionsStyles)
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData',
            'getTemplateDataChanged',
            'getProductSections',
            'getProductSectionsStyles',
            'getColorSchemeColors',
            'getColorSchemeFontColors'
        ]),
		productSections: {
			get() {
				return this.getProductSections
			},
			set(value) {
				this.updateProductSections(value)
			}
		},
		productSectionsOptions() {
			return {
				group: { name: "product_sections" },
				draggable: ".draggable",
				ghostClass: "sortable-ghost",
				chosenClass: "sortable-chosen",
				dragClass: "sortable-drag"
			}
		},
        productContainerOuterStyle() {
            return { backgroundColor: this.getColorSchemeColors[this.getTemplateData.siteOptions.backgroundColor.value] || this.getColorSchemeColors[this.getTemplateData.siteOptions.backgroundColor.defaultColor] }
        }
	},
    methods: {
        ...mapActions('website_module', [
            'updateProductSections',
            'updateProductSectionsStyles',
            'revertTemplateData',
            'saveTemplateData'
        ])
    }
}
</script>

<style lang="scss" scoped>
label.checkbox {
	display: contents !important;
	span {
		margin: 1rem 0;
	}
}
</style>
